export default __webpack_public_path__ + "static/media/launchpad_video.bf5e2376.mp4";